import { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { TiTick } from "react-icons/ti";
import AddressInputSection from "./AddressInputSection";
import Loader from "../../../utils/Loader";

const RestSettingsDetail = (props) => {
    const { refreshLogo, hasPermission } = props;
    const { rest_slug2 } = useParams();
    const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
    const token = localStorage.getItem("token");
    const [isLoading, setIsLoading] = useState(false);
    const [restaurantName, setRestaurantName] = useState("");
    const [collaborationDescription, setCollaborationDescription] = useState("");
    const [wineListName, setWineListName] = useState("");
    const [menuListName, setMenuListName] = useState("");
    const [bevarageListName, setBevarageListName] = useState("");
    const [showMoreName, setShowMoreName] = useState("");
    const [otherWineTitle, setOtherWineTitle] = useState("");
    const [logo, setLogo] = useState(null);
    const [selectedLogo, setSelectedLogo] = useState(null);
    const [logoError, setLogoError] = useState('');
    const logoUrl = import.meta.env.VITE_BACKEND_APP_STORAGE_URL;

    const [profileSettingsData, setProfileSettingsData] = useState([]);

    const [addresses, setAddresses] = useState([]);

    const [allProvinceData, setAllProvinceData] = useState([]);
    const [showOptionProvince, setShowOptionProvince] = useState({});
    const [searchQueryProvince, setSearchQueryProvince] = useState("");

    const getRestProfileData = useCallback(async () => {
        try {
            const responseProfileData = await axios.get(`${apiUrl}/api/v1/restaurants/${rest_slug2}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setProfileSettingsData(responseProfileData.data);
            const AddAdressData = responseProfileData?.data?.addresses?.map((data) => ({
                label: data.address_title || "",
                address: data.address || "",
                city: data.city || "",
                postal_code: data.postal_code || "",
                province: data.province || "",
                telephone: data.telephone || "",
                mobile_no: data.mobile_no || "",
                email: data.email || ""
            })) || [];
            setAddresses(AddAdressData);
        } catch (error) {
            console.error('Error fetching Profile Settings data:', error);
        }
    }, [apiUrl, rest_slug2, token]);

    useEffect(() => {
        const fetchAllProvince = async () => {
            try {
                const response = await axios.get(`${apiUrl}/api/v1/provinces`, {
                    headers: { Authorization: `Bearer ${token}` },
                });

                setAllProvinceData(response?.data || []);
            } catch (error) {
                console.error("Error fetching all wines", error);
            }
        };
        fetchAllProvince();
    }, [apiUrl, token]);


    const handleAddressesChange = (updatedAddresses) => {
        setAddresses(updatedAddresses);
    };

    const toggleDropdownProvince = (key) => {
        setShowOptionProvince(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
        setSearchQueryProvince("");
    };

    const filteredProvinceList = allProvinceData.filter((option) =>
        option?.name?.toLowerCase().includes(searchQueryProvince.toLowerCase())
    );

    const handleSave = async () => {
        if (!logoError) {
            const formData = new FormData();

            formData.append('restaurant_id', rest_slug2);
            formData.append('restaurant_name', restaurantName);
            formData.append('collaboration_description', collaborationDescription);
            formData.append('wineListName', wineListName);
            formData.append('menuListName', menuListName);
            formData.append('beverageListName', bevarageListName);
            formData.append('show_more', showMoreName);
            formData.append('other_wine_title', otherWineTitle);

            if (selectedLogo) {
                formData.append('logo', selectedLogo);
            }

            addresses.forEach((addr, index) => {
                formData.append(`addresses[${index}][label]`, addr.label);
                formData.append(`addresses[${index}][address]`, addr.address);
                formData.append(`addresses[${index}][city]`, addr.city);
                formData.append(`addresses[${index}][postal_code]`, addr.postal_code);
                formData.append(`addresses[${index}][province]`, addr.province);
                formData.append(`addresses[${index}][telephone]`, addr.telephone);
                formData.append(`addresses[${index}][mobile_no]`, addr.mobile_no);
                formData.append(`addresses[${index}][email]`, addr.email);
            });

            try {
                setIsLoading(true);
                const response = await axios.post(`${apiUrl}/api/v1/restaurant-info`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: `Bearer ${token}`,
                    },
                });

                const data = response.data;
                refreshLogo();
                toast.success(data?.message, { theme: "colored", autoClose: 1000 });
            } catch (error) {
                console.error('Error saving restaurant Information:', error);
                const errors = error?.response?.data?.errors;
                if (errors) {
                    for (const key in errors) {
                        if (Array.isArray(errors[key])) {
                            errors[key].forEach((message) => {
                                toast.error(message, {
                                    theme: 'colored',
                                    autoClose: 3000,
                                });
                            });
                        }
                    }
                } else {
                    toast.error(error?.response?.data?.message, {
                        theme: "colored",
                        autoClose: 3000,
                    });
                }
            } finally {
                setIsLoading(false);
            }
        } else {
            toast.error(logoError, { theme: "colored", autoClose: 1000 });
        }
    };

    const handleLogoChange = (e) => {
        const file = e.target.files?.[0];
        if (!file) {
            setLogoError('No file selected');
            return;
        }

        // 1. FILE SIZE CHECK (2MB max)
        const maxSizeInBytes = 2 * 1024 * 1024; // 2MB
        if (file.size > maxSizeInBytes) {
            setLogoError("Max size: 2MB. Compress your image first.");
            return;
        }

        // 2. STRICT DIMENSION VALIDATION (must be exactly 249×94)
        const img = new Image();
        img.onload = () => {
            const REQUIRED_WIDTH = 249;
            const REQUIRED_HEIGHT = 94;

            if (img.width !== REQUIRED_WIDTH || img.height !== REQUIRED_HEIGHT) {
                setLogoError(`Image must be exactly ${REQUIRED_WIDTH}x${REQUIRED_HEIGHT}px.`);
                return;
            }

            // Validation passed
            setLogoError('');
            setLogo(URL.createObjectURL(file));
            setSelectedLogo(file);
        };

        img.onerror = () => {
            setLogoError('Invalid image file');
        };

        img.src = URL.createObjectURL(file);
    };

    useEffect(() => {
        getRestProfileData();
    }, [getRestProfileData]);

    useEffect(() => {
        if (profileSettingsData) {
            setRestaurantName(profileSettingsData?.restaurant_name || "");
            setCollaborationDescription(profileSettingsData?.collaboration_description || "");
            setWineListName(profileSettingsData?.wineListName || "");
            setMenuListName(profileSettingsData?.menuListName || "");
            setBevarageListName(profileSettingsData?.beverageListName || "");
            setOtherWineTitle(profileSettingsData?.other_wine_title || "");
            setLogo(profileSettingsData?.logo ? `${logoUrl}/${profileSettingsData?.logo}` : null);
        }
    }, [profileSettingsData, logoUrl]);

    return (
        <>
            <section className="border-t border-[#D9D9D9] md:mt-5 md:pt-10 pt-5">
                <h3 className="md:ext-2xl text-2xl font-bold mb-5 poppins-medium">Informazioni del locale</h3>
                <div className="w-full h-auto bg-[#FCFCFC] text-left text-red-700 space-y-5 border-[2px] border-[#8B24332B] sm:p-10 p-5 rounded-xl shadow-md font-sans">
                    <div className="flex flex-col space-y-3 lg:space-y-4 mb-4">
                        <div className="shadow-md space-y-3 mt-2 lg:mt-5 px-5 py-8 border rounded-lg">
                            <div className="flex flex-col lg:flex-row gap-5 mb-4">
                                <div className="flex flex-col w-full space-y-3 if-01">
                                    <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                        Nome Locale:
                                    </label>
                                    <input
                                        type="text"
                                        className="poppins-regular w-full px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none  focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                        value={restaurantName || ""}
                                        onChange={(e) => setRestaurantName(e.target.value)}
                                    />
                                </div>
                                <div className="flex flex-col w-full space-y-3 if-01">
                                    <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                        Titolo Le nostre carte vini:
                                    </label>
                                    <input
                                        type="text"
                                        className="poppins-regular w-full px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none  focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                        value={wineListName || ""}
                                        onChange={(e) => setWineListName(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="flex flex-col lg:flex-row gap-5 mb-4">
                                <div className="flex flex-col w-full space-y-3">
                                    <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                        Titolo I nostri menu:
                                    </label>
                                    <input
                                        type="text"
                                        className="poppins-regular w-full px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none  focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                        value={menuListName || ""}
                                        onChange={(e) => setMenuListName(e.target.value)}
                                    />
                                </div>
                                <div className="flex flex-col w-full space-y-3">
                                    <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                        Titolo Che vino ci abbino?:
                                    </label>
                                    <input
                                        type="text"
                                        className="poppins-regular w-full px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none  focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                        value={showMoreName || ""}
                                        onChange={(e) => setShowMoreName(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="flex flex-col lg:flex-row gap-5 mb-4">
                                <div className="flex flex-col w-full space-y-3">
                                    <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                        Titolo I nostri bevande:
                                    </label>
                                    <input
                                        type="text"
                                        className="poppins-regular w-full px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none  focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                        value={bevarageListName || ""}
                                        onChange={(e) => setBevarageListName(e.target.value)}
                                    />
                                </div>
                                <div className="flex flex-col w-full space-y-3">
                                    <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                        Titolo Altri Vini:
                                    </label>
                                    <input
                                        type="text"
                                        className="poppins-regular w-full px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none  focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                        value={otherWineTitle || ""}
                                        onChange={(e) => setOtherWineTitle(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="flex flex-col lg:flex-row gap-5 mb-4">
                                <div className="flex flex-col w-full space-y-3">
                                    <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                        Descrizione Collaborazione:
                                    </label>
                                    <textarea
                                        className="poppins-regular px-4 py-1 h-[100px] text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none  focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                        rows={6}
                                        value={collaborationDescription && collaborationDescription.replace(/<[^>]+>/g, '') || ""}
                                        onChange={(e) => setCollaborationDescription(e.target.value)}
                                    />
                                </div>
                                <div className="flex flex-col w-full space-y-3">
                                    <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                        Logo:
                                    </label>
                                    <div className="text-xs text-[#8B8B8B] poppins-regular">
                                        Recommended ratio: 249 x 94 px | Max size: 2MB
                                    </div>
                                    <div className="file-input poppins-regular px-4 py-3 text-[12px] text-[#8B8B8B] rounded-[50px] bg-transparent border border-gray-300 focus:outline-none focus:border-gray-400 focus:bg-[#e2dbdb]">
                                        <input type="file" onChange={handleLogoChange} accept="image/*" />
                                        <span className="button">Choose</span>
                                        <span className="label" data-js-label>No file selected</span>
                                    </div>
                                    {logoError && (
                                        <div className="text-xs text-red-500 mt-1">
                                            {logoError}
                                        </div>
                                    )}
                                    {logo && !logoError && (
                                        <div className="overflow-hidden mt-[10px] cursor-pointer h-full w-[100px] flex items-center justify-center">
                                            <img
                                                src={logo}
                                                alt="Preview"
                                                className="w-full object-cover rounded-lg shadow-md"
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <AddressInputSection
                            addresses={addresses}
                            setAddresses={setAddresses}
                            onAddressesChange={handleAddressesChange}

                            searchQueryProvince={searchQueryProvince}
                            setSearchQueryProvince={setSearchQueryProvince}
                            allProvinceData={allProvinceData}
                            filteredProvinceList={filteredProvinceList}
                            toggleDropdownProvince={toggleDropdownProvince}
                            showOptionProvince={showOptionProvince}
                            setShowOptionProvince={setShowOptionProvince}
                        />
                    </div>
                    <div className="flex text-sm sm:flex-row flex-col justify-start gap-4 mt-10">
                        {(hasPermission("Restaurant_info", "add") || hasPermission("Restaurant_info", "edit")) && (
                            <>
                                {isLoading ? (
                                    <button disabled type="button"
                                        className="sm:w-[120px] w-full poppins-regular justify-center flex items-center space-x-2 p-1 px-3 bg-[#8A2533] text-white border-[1.5px] border-[#d18d97] rounded-lg transition-colors group">
                                        <Loader />
                                        Loading...
                                    </button>
                                ) : (
                                    <button className="sm:w-[120px] w-full justify-center flex items-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#d18d97] text-red-700 rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
                                        onClick={handleSave}
                                    >
                                        <TiTick size={"25px"} color="green" />
                                        <span className="poppins-regular">Aggiorna</span>
                                    </button>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </section>
        </>
    )
}

RestSettingsDetail.propTypes = {
    refreshLogo: PropTypes.func.isRequired,
    hasPermission: PropTypes.func.isRequired,
};

export default RestSettingsDetail; 